import { useState, useEffect, useRef, useCallback } from 'react';
import GetDataApi from '../../Components/Common/FetchData/GetDataApi';
import { debounce } from '../../Components/Common/debounce';
import { Form, InputGroup } from 'react-bootstrap';
import { RxCrossCircled } from 'react-icons/rx';

export type ICategory = {
  id: number;
  name: string;
  created_by: number;
  status: number;
  is_default: number;
  fair_id: number;
  created_at: string;
};
type IProps = {
  label?: string;
  placeholder?: string;
  onChange?: (data: ICategory | null) => void;
};

const CategorySelectSearchField = ({
  label,
  placeholder,
  onChange,
}: IProps) => {
  const [exhibotorTerm, setExhibitorTerm] = useState<string>('');
  const { response, loading, getData } = GetDataApi<ICategory[]>(
    `/api/fair/product-category/public?name=${exhibotorTerm}`,
    true
  );
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [selectedValue, setSelectedValue] = useState<ICategory | null>();
  const dropdownRef = useRef<HTMLDivElement>(null); // Reference to the dropdown wrapper

  useEffect(() => {
    if (exhibotorTerm) {
      getData();
    } else {
      getData();
    }
  }, [exhibotorTerm]);

  const handleSelect = (option: ICategory) => {
    setSelectedValue(option);
    setShowDropdown(false);
    onChange && onChange(option);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSearch = useCallback(
    debounce((value: string) => {
      setExhibitorTerm(value);
    }, 500),
    []
  );

  return (
    <div className='position-relative' ref={dropdownRef}>
      {label && (
        <label>
          {label} <span className='require'>*</span>
        </label>
      )}

      <div
        className='form-control'
        onClick={() => {
          setShowDropdown(!showDropdown);
        }}
        style={{ cursor: 'pointer', textAlign: 'start', position: 'relative' }}
      >
        {selectedValue?.name || (
            <span style={{ color: 'gray' }}>Select {placeholder || ''}</span>
          ) ||
          `Select ${label || ''}`}

        <span
          style={{ position: 'absolute', right: 5, zIndex: 100, top: 4 }}
          onClick={(e) => {
            e.stopPropagation();
            setSelectedValue(null);
            onChange && onChange(null);
          }}
        >
          <RxCrossCircled />
        </span>
      </div>
      {showDropdown && (
        <div
          className='position-absolute border bg-white w-100'
          style={{ zIndex: 1000 }}
        >
          <InputGroup onChange={(e: any) => handleSearch(e.target.value)}>
            <Form.Control
              placeholder={`Search ${placeholder || ''}`}
              aria-label='Username'
              aria-describedby='basic-addon1'
            />
          </InputGroup>

          <div
            style={{ maxHeight: '200px', overflow: 'auto', textAlign: 'start' }}
          >
            {loading ? (
              <div className='p-2'>Loading...</div>
            ) : response?.length && response ? (
              response?.map((option) => (
                <div
                  key={option.id}
                  className='p-2 hover-bg-light selectfieldListHover'
                  onClick={() => handleSelect(option)}
                  style={{ cursor: 'pointer' }}
                >
                  {option.name}
                </div>
              ))
            ) : (
              <div className='p-2'>No results found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategorySelectSearchField;
